import { create } from 'zustand'
import { marketApi } from '../services'

const useMarketStore = create((set, get) => ({
  // Состояние
  skins: [], // Список скинов в магазине
  availableFilters: {}, // Доступные фильтры из API (exterior, rarity, type)
  isLoading: false,
  
  // Текущие фильтры пользователя
  filters: {
    stattrak: 'any',
    souvenir: 'any',
    exterior: 'any',
    rarity: 'any',
    type: 'any',
    price_start: 'any',
    price_finish: 'any',
    search_string: 'any',
  },
  
  // Пагинация
  displayCount: 30, // Сколько скинов показываем
  totalLoaded: 0, // Сколько всего загружено
  
  /**
   * Загрузка начальных данных магазина (GET /api/market/)
   */
  loadInitialData: async () => {
    set({ isLoading: true })
    try {
      const { found, filter } = await marketApi.getInitialData()
      
      set({ 
        skins: found || [],
        availableFilters: filter || {},
        totalLoaded: found?.length || 0,
        displayCount: 30,
      })
      
      return { found, filter }
    } catch (error) {
      console.error('❌ Ошибка загрузки данных магазина:', error)
      set({ skins: [], availableFilters: {} })
      throw error
    } finally {
      set({ isLoading: false })
    }
  },
  
  /**
   * Применение фильтров (POST /api/market/)
   */
  applyFilters: async () => {
    set({ isLoading: true })
    try {
      const currentFilters = get().filters
      const found = await marketApi.applyFilters(currentFilters)
      
      set({ 
        skins: found || [],
        totalLoaded: found?.length || 0,
        displayCount: 30, // Сбрасываем к начальному значению
      })
      
      return found
    } catch (error) {
      console.error('❌ Ошибка применения фильтров:', error)
      set({ skins: [] })
      throw error
    } finally {
      set({ isLoading: false })
    }
  },
  
  /**
   * Обновление конкретного фильтра
   */
  updateFilter: (filterName, value) => {
    set((state) => ({
      filters: {
        ...state.filters,
        [filterName]: value,
      },
    }))
  },
  
  /**
   * Сброс всех фильтров
   */
  resetFilters: () => {
    set({
      filters: {
        stattrak: 'any',
        souvenir: 'any',
        exterior: 'any',
        rarity: 'any',
        type: 'any',
        price_start: 'any',
        price_finish: 'any',
        search_string: 'any',
      },
    })
  },
  
  /**
   * Показать еще 30 скинов
   */
  loadMore: () => {
    set((state) => ({
      displayCount: state.displayCount + 30,
    }))
  },
  
  /**
   * Покупка скина
   */
  buySkin: async (skinName) => {
    try {
      const { purchasedSkin, user } = await marketApi.buySkin(skinName)
      
      // Баланс обновится автоматически через processUnifiedResponse в api.js
      return { purchasedSkin, user }
    } catch (error) {
      console.error('❌ Ошибка покупки скина:', error)
      throw error
    }
  },
}))

export default useMarketStore
